import { searchResizeCorner } from './utils'

export function resize(
  definition,
  absolutePoint,
  itemViews,
  interaction,
  methods,
) {
  //search resize corner
  const { status, itemView } = searchResizeCorner(
    itemViews,
    definition.resizableEntities,
    definition.hitDetection,
    absolutePoint,
  )
  if (!itemView) return null

  //set history item
  methods.setHistory({
    type: 'resize',
    itemView: itemView,
    prevValue: { ...itemView.boundary },
  })

  //stop checking of interations
  return {
    status: status,
    currentItemView: itemView,
    resizeOptions: {
      startX: absolutePoint.x,
      startY: absolutePoint.y,
    },
  }
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/resize.js